import { render, staticRenderFns } from "./mainBtn.vue?vue&type=template&id=6c74466e"
import script from "./mainBtn.vue?vue&type=script&lang=js"
export * from "./mainBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports